import { MenuItemNavigation } from '@hub/shared'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './campaign-footer-mobile.component.scoped.scss'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  menu?: Array<MenuItemNavigation>
}

export default ({ className = '', style = {}, menu = [] }: Props) => {
  const [prev, setPrev] = useState(0)
  const [next, setNext] = useState(2)
  const [current, setCurrent] = useState(1)

  useEffect(() => {
    const current = menu?.findIndex((item) => item.path === window.location.pathname)
    setCurrent(current)
    if (current > -1) {
      if (current > 0) {
        setPrev(current - 1)
        if (current < menu?.length - 1) {
          setNext(current + 1)
        } else {
          setNext(0)
        }
      } else {
        setPrev(menu?.length - 1)
        setNext(current + 1)
      }
    }
  }, [menu])

  return (
    <section className={`${className} campaign-mobile-footer`} style={style}>
      <Link to={menu[prev]?.path} className="left">
        <i className="fa-regular fa-arrow-left-long campaign-mobile-footer-icon"></i>{' '}
        <span title={menu?.[prev]?.label}>{menu?.[prev]?.label}</span>
      </Link>
      <Link to={menu[next]?.path} className="right">
        <span title={menu?.[next]?.label}>{menu?.[next]?.label}</span>{' '}
        <i className="fa-regular fa-arrow-right-long campaign-mobile-footer-icon"></i>
      </Link>
    </section>
  )
}
